var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.60007 9.39716L1.59994 5.88533C1.5999 5.00166 2.31625 4.28528 3.19992 4.28528L12.8001 4.2852C13.6837 4.2852 14.4001 5.00154 14.4001 5.88521V9.39716M1.60007 9.39716H14.4001M1.60007 9.39716L1.59993 13.0851C1.5999 13.9688 2.31626 14.6852 3.19993 14.6852H12.8001C13.6837 14.6852 14.4001 13.9688 14.4001 13.0852V9.39716M8.11643 14.6852V4.28519M7.30954 3.9484C7.42934 3.94348 7.5401 3.88049 7.59966 3.77732C7.65922 3.67416 7.65834 3.54672 7.60276 3.44053C7.39031 3.05339 6.64494 1.76615 6.1585 1.4853C5.55245 1.1354 4.77399 1.34185 4.42582 1.9449C4.07767 2.54791 4.28804 3.32532 4.89413 3.67525C5.38854 3.9607 6.86806 3.95799 7.30954 3.9484ZM8.42313 3.44042C8.36749 3.54664 8.36666 3.67405 8.42622 3.77721C8.48578 3.88038 8.5966 3.94333 8.71634 3.94829C9.15784 3.95788 10.6453 3.95599 11.1318 3.67514C11.7378 3.32524 11.9482 2.54785 11.6001 1.9448C11.2519 1.34179 10.4735 1.13527 9.86738 1.48519C9.37298 1.77064 8.63556 3.05329 8.42313 3.44042Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.f6c17bcf7fd49b143a82802a21292d8c.svg";
export { ForwardRef as ReactComponent };